import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";

import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Timeline from "@material-ui/icons/Timeline";
import Code from "@material-ui/icons/Code";
import Group from "@material-ui/icons/Group";
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
import CompanyIcon from "@material-ui/icons/Copyright";
// import LockOutline from "@material-ui/icons/LockOutline";
import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import { connect } from "react-redux";
import { patchAddUser } from "api/login/index";
import { withRouter } from "react-router";

import { fetchTermCondition, fetchCompany } from "api/notification/index";

import registerPageStyle from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";

class RegisterPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: [],
      username: "",
      email: "",
      password: "",
      confirmpassword: "",
      description: "",
      errormsg: "",
      colormsg: "red",
      company: ""
    };
    this.handleToggle = this.handleToggle.bind(this);
  }
  handleToggle(value) {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    console.log(newChecked);

    this.setState({
      checked: newChecked
    });
  }

  handleUsername = event => {
    this.setState({ username: event.target.value });
  };

  handleEmail = event => {
    this.setState({ email: event.target.value });
  };

  handlePassword = event => {
    this.setState({ password: event.target.value });
  };

  handleConfirmPassword = event => {
    this.setState({ confirmpassword: event.target.value });
  };


  handleCompany = event => {
    this.setState({ company: event.target.value });
  };

  pushAddUser = () => {

    if(this.state.company != ""){
      fetchCompany(this.state.company)
        .then(response => {

          if (response.data.count > 0) {

            let company_limit = response.data.results[0].company_limit;

            const actuser = 3;

            if(company_limit >= actuser){
              console.log('available');

              if (this.state.username == "" || this.state.email == "") {
                this.setState({ errormsg: "Please field input correctly!", colormsg: "red" });
              } else if (this.state.password != this.state.confirmpassword) {
                this.setState({ errormsg: "Password not corrects!", colormsg: "red" });
              } else if (this.state.checked.length <= 0) {
                this.setState({ errormsg: "Please check term of condition!", colormsg: "red" });
              } else {
                this.setState({ errormsg: "" });
                patchAddUser(
                  this.state.username,
                  this.state.email,
                  this.state.password,
                  this.state.company,
                  "",
                  ""
                )
                  .then(response => {
                    if (response != null) {
                      console.log("berhasil");
                      this.setState({
                        errormsg: "Success, Go to login!",
                        colormsg: "green"
                      });
                    }
                  })
                  .catch(error => {
                    console.log("tidak berhasil");
                  });
              }

            }else{
              this.setState({ errormsg: "Company limited users", colormsg: "red" });

            }
          }else{
            this.setState({ errormsg: "Company not found", colormsg: "red" });
          }



        })
        .catch(error => {
          //this.props.pushToken(error);
        });
    } else {
      this.setState({ errormsg: "Please input your company code", colormsg: "red" });
    }

  };

  componentDidMount() {
    fetchTermCondition()
      .then(response => {
        if (response != null) {
          this.setState({
            open: true,
            description: response.data.results[0].description
          });
        }
      })
      .catch(error => {
        //this.props.pushToken(error);
      });

  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={10}>
            <Card className={classes.cardSignup}>
              <h2 className={classes.cardTitle}>Register</h2>
              <CardBody>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={5}>
                    {/*<InfoArea
                      title="Monitoring"
                      description="We've created the monitoring campaign of the website. It was a very interesting collaboration."
                      icon={Timeline}
                      iconColor="rose"
                    />
                    <InfoArea
                      title="Data Analityc"
                      description="Get your spatial data analityc in one dashboard."
                      icon={Code}
                      iconColor="primary"
                    />
                    <InfoArea
                      title="Communities"
                      description="Create community data, use and combine it with yours."
                      icon={Group}
                      iconColor="info"
                    />*/}
                    <div style={{height: "auto"}}>
                      <p><b>Term and condition</b></p>
                      {this.state.description}
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={8} md={5}>
                    {/*<div className={classes.center}>

                      <Button justIcon round color="facebook">
                        <i className="fab fa-facebook-f" />
                      </Button>
                      {` `}
                      <h4 className={classes.socialTitle}>or be classical</h4>
                    </div>*/}
                    <form className={classes.form}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                          className: classes.customFormControlClasses
                        }}
                        on
                        inputProps={{
                          startAdornment: (
                            <InputAdornment
                              position="start"
                              className={classes.inputAdornment}
                            >
                              <CompanyIcon className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                          ),
                          onChange: this.handleCompany,
                          placeholder: "Company Code"
                        }}
                      />
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                          className: classes.customFormControlClasses
                        }}
                        on
                        inputProps={{
                          startAdornment: (
                            <InputAdornment
                              position="start"
                              className={classes.inputAdornment}
                            >
                              <Face className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                          ),
                          onChange: this.handleUsername,
                          placeholder: "First Name..."
                        }}
                      />
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                          className: classes.customFormControlClasses
                        }}
                        inputProps={{
                          startAdornment: (
                            <InputAdornment
                              position="start"
                              className={classes.inputAdornment}
                            >
                              <Email className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                          ),
                          onChange: this.handleEmail,
                          placeholder: "Email..."
                        }}
                      />
                      {/* <CustomInput
                        formControlProps={{
                          fullWidth: true,
                          className: classes.customFormControlClasses
                        }}
                        inputProps={{
                          type: "password",
                          startAdornment: (
                            <InputAdornment
                              position="start"
                              className={classes.inputAdornment}
                            >
                              <Icon className={classes.inputAdornmentIcon}>
                                lock_outline
                              </Icon>
                            </InputAdornment>
                          ),
                          onChange: this.handlePassword,
                          placeholder: "Password"
                        }}
                      /> */}
                      {/* <CustomInput
                        formControlProps={{
                          fullWidth: true,
                          className: classes.customFormControlClasses
                        }}
                        inputProps={{
                          type: "password",
                          startAdornment: (
                            <InputAdornment
                              position="start"
                              className={classes.inputAdornment}
                            >
                              <Icon className={classes.inputAdornmentIcon}>
                                lock_outline
                              </Icon>
                            </InputAdornment>
                          ),
                          onChange: this.handleConfirmPassword,
                          placeholder: "Confirm Password"
                        }}
                      />*/}
                      <FormControlLabel
                        classes={{
                          root: classes.checkboxLabelControl,
                          label: classes.checkboxLabel
                        }}
                        control={
                          <Checkbox
                            tabIndex={-1}
                            onClick={() => this.handleToggle(1)}
                            checkedIcon={
                              <Check className={classes.checkedIcon} />
                            }
                            icon={<Check className={classes.uncheckedIcon} />}
                            classes={{
                              checked: classes.checked,
                              root: classes.checkRoot
                            }}
                          />
                        }
                        label={
                          <span>
                            I agree to the{" "}
                            <a href="#pablo">terms and conditions</a>.
                          </span>
                        }
                      />
                      <div className={classes.center}>
                        <font style={{ color: `${this.state.colormsg}` }}>
                          {this.state.errormsg}
                        </font>
                        <br/>
                        <Button
                          round
                          color="primary"
                          onClick={this.pushAddUser}
                        >
                          Get started
                        </Button>

                      </div>
                    </form>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

RegisterPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(registerPageStyle)(RegisterPage);
